/* Cats Garage — product-tabs.js
   Progressive tabs for the PDP info panels ([data-cg-tabs]).
   Without JS all panels render stacked (each is a titled card); with JS the
   tab bar appears (.is-ready) and one panel shows at a time. */
(function () {
  'use strict';

  document.querySelectorAll('[data-cg-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-tab-target]');
    if (!buttons.length) return;

    function activate(name) {
      buttons.forEach(function (button) {
        var on = button.getAttribute('data-tab-target') === name;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      tabs.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === name);
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activate(button.getAttribute('data-tab-target'));
      });
    });

    tabs.classList.add('is-ready');
    activate(buttons[0].getAttribute('data-tab-target'));
  });
})();
